<div *ngIf="loaded" class="d-flex w-100" [style.background-color]="venueService.ooVenue.styles?.siteBgColor">
	<div class="card checkout mx-auto">
		<div class="p-grid checkout-section-card">
			<div class="p-col-12 p-md-6">
				<div class="d-flex">
					<div class="ms-auto card w-100">
						<app-check-out-order-type-select></app-check-out-order-type-select>
					</div>
				</div>
				<div class="d-flex">
					<div class="ms-auto card w-100">
						<app-check-out-due-time-select></app-check-out-due-time-select>
					</div>
				</div>
				<div class="d-flex">
					<div class="ms-auto card w-100">
						<app-check-out-order-type-fields></app-check-out-order-type-fields>
					</div>
				</div>
				<div class="d-flex">
					<div class="ms-auto card w-100">
						<app-check-out-order-details></app-check-out-order-details>
					</div>
				</div>
				<div class="d-flex">
					<div class="ms-auto card w-100">
						<app-check-out-cart></app-check-out-cart>
					</div>
				</div>
			</div>
			<div class="p-col-12 p-md-6">
				<div class="d-flex me-auto">
					<div class="card w-100">
						<app-check-out-payment-select></app-check-out-payment-select>
					</div>
				</div>
				<div class="d-flex me-auto">
					<div class="card w-100">
						<app-check-out-promo-codes></app-check-out-promo-codes>
					</div>
				</div>
				<div class="d-flex me-auto">
					<div class="card w-100">
						<app-check-out-footer></app-check-out-footer>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
